// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  font-size: 24px;
  font-weight: bold;
}

h5 {
  font-size: 16px;
  font-weight: bold !important;
  margin: 5px 0 !important;
}

h6 {
  font-size: 16px;
  font-weight: 550;
  margin: 5px 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/account-balance/account-balance.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,eAAA;EACA,4BAAA;EACA,wBAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,wBAAA;AACJ","sourcesContent":["h2{\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n}\r\n\r\nh5{\r\n    font-size: 16px;\r\n    font-weight: bold!important;\r\n    margin: 5px 0!important;\r\n}\r\n\r\nh6{\r\n    font-size: 16px;\r\n    font-weight: 550;\r\n    margin: 5px 0!important;\r\n}\r\n\r\n// ion-button{\r\n//     width: 140px;\r\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
